import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";
import { FAQ, FAQ_INTRO } from "../data/site";

export const Faq = () => (
  <section id="gyik" data-testid="faq-section" className="scroll-mt-24 bg-cream2 py-24 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading eyebrow={FAQ_INTRO.eyebrow} title={FAQ_INTRO.title} />

      <Reveal delay={0.1} className="mt-12 max-w-3xl">
        <Accordion type="single" collapsible className="space-y-4">
          {FAQ.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-3xl border border-line bg-white px-6 card-shadow"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-base font-semibold text-ink hover:no-underline"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-soft sm:text-base">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
